module.exports = __webpack_public_path__ + "static/media/Icon_menu_purchasing_expert_white.28e0704f.svg";